import React, { Component } from 'react';
import '../assets/css/bootstrap.min.css';
import '../assets/css/style.css';
import { Link } from 'react-router-dom';
import itemImg from '../assets/images/upcoming-collection-artwork-page/artwork-sample-1.png';
import buyerIcon from '../assets/images/user-profile/profile-picture.png';
import card1 from '../assets/images/Marketplace/artwork-card-1.png';
import card2 from '../assets/images/Marketplace/artwork-card-2.png';
import card3 from '../assets/images/Marketplace/artwork-card-3.png';
import card4 from '../assets/images/Marketplace/artwork-card-4.png';
import card5 from '../assets/images/Marketplace/artwork-card-5.png';
import card6 from '../assets/images/Marketplace/artwork-card-6.png';
import card7 from '../assets/images/Marketplace/artwork-card-7.png';
import card8 from '../assets/images/Marketplace/artwork-card-8.png';
import collectionCard1 from '../assets/images/Marketplace-Filtered-by-Artwork/Asset-25.png';
import collectionCard2 from '../assets/images/Marketplace-Filtered-by-Artwork/Asset-26.png';
import collectionCard3 from '../assets/images/Marketplace-Filtered-by-Artwork/Asset-27.png';
import Header from './Header';

class FilteredArtworkViewCollection extends Component {
    render() {
        return (
            <div className="main-wrapper">
                {/* Header area start */}
                <Header />
                {/* Header area end */}

                {/* Item details area start */}
                <div className="container mb-3">
                    <div className="row collection justify-content-between">
                    <div className="col-md-6 upcoming-collection">
                            <img src={itemImg} alt="" width="100%" />
                            <p><Link to="#">VIEW COLLECTION</Link>
                                <small className="pull-right">Contract Address</small>
                            </p>
                            <small className="pull-right">0xbfb69918f12eed843c67058b2ee9059f1440133e</small>
                        </div>
                        
                        <div className="col-lg-5 mt-auto mb-auto view-collection upcoming">
                            <h3>Artist Name</h3>
                            <h1>Artwork Title #6/26
                                <span>
                                    Owned by <Link to="#">NFTYbuyer1 </Link>
                                    <img src={buyerIcon} alt="buyer" />
                                </span>
                            </h1>
                            <hr />
                            <p>Collection Title
                                <span>Edition of 26</span>
                            </p>
                            <h6>ITEM DESCRIPTION. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. Duis autem vel</h6>
                            <h2>$8,000.00
                                <span>$9,000.00</span>
                            </h2>
                            <h5>Original Listing
                                <span>Highest Bid</span>
                            </h5>
                            <h2>$8,500
                                <span>$10,000.00</span>
                            </h2>
                            <h5>Last Sold
                                <span>Lowest Ask</span>
                            </h5>
                        </div>
                    </div>
                </div>
                {/* Item details area end */}

                {/* three images start */}
                <div className="container">
                    <div className="row images">
                        <div className="col-lg-5">
                            <div className="row justify-content-center">
                                <div className="col-lg-4">
                                    <div className="card">
                                        <img className="card-img-top" src={collectionCard1} alt="" />
                                        <div className="card-body1">
                                            <h5 className="card-title">Artwork Title</h5>
                                            <p><strong>$10,000.00</strong><span>26 Editions</span>&emsp;</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="card">
                                        <img className="card-img-top" src={collectionCard2} alt="" />
                                        <div className="card-body1">
                                            <h5 className="card-title">Artwork Title</h5>
                                            <p><strong>$10,000.00</strong><span>26 Editions</span>&emsp;</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="card">
                                        <img className="card-img-top" src={collectionCard3} alt="" />
                                        <div className="card-body1">
                                            <h5 className="card-title">Artwork Title</h5>
                                            <p><strong>$10,000.00</strong><span>26 Editions</span>&emsp;</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* three images end */}

                {/* MArketplace area start */}
                <div className="container-fluid">
                    <main className="row main">
                        <nav id="navbar">
                            <ul className="text-left">
                                <li className="nav-link"><h1>Filters</h1></li>
                                <li className="nav-link">
                                    <label className="switch">
                                        <input type="checkbox" />
                                        <span className="slider round"></span>
                                    </label>
                                </li>
                                <li className="nav-link"><h3>Artists</h3></li>
                                <li><Link className="nav-link" to="#Title1">Alorem</Link></li>
                                <li><Link className="nav-link" to="#Title2">Artist Name</Link></li>
                                <li><Link className="nav-link" to="#Title3">Blorem</Link></li>
                                <li><Link className="nav-link" to="#Title4">Clorem</Link></li>
                                <li><Link className="nav-link" to="#Title5">Alorem</Link></li>
                                <li><Link className="nav-link" to="#Title6">Azorem</Link></li>
                                <li><Link className="nav-link" to="#Title1">Alorem</Link></li>
                                <li><Link className="nav-link" to="#Title2">Artist Name</Link></li>
                                <li><Link className="nav-link" to="#Title3">Blorem</Link></li>
                                <li><Link className="nav-link" to="#Title4">Clorem</Link></li>
                                <li><Link className="nav-link" to="#Title5">Alorem</Link></li>
                                <li><Link className="nav-link" to="#Title6">Azorem</Link></li>
                                <li><Link className="nav-link" to="#Title1">Alorem</Link></li>
                                <li><Link className="nav-link" to="#Title2">Artist Name</Link></li>
                                <li><Link className="nav-link" to="#Title3">Blorem</Link></li>
                                <li><Link className="nav-link" to="#Title4">Clorem</Link></li>
                                <li><Link className="nav-link" to="#Title5">Alorem</Link></li>
                                <li><Link className="nav-link" to="#Title6">Azorem</Link></li>
                            </ul>
                        </nav>
                        <nav className="navbar">
                            <ul className="text-left">
                                <h1 className="">Collections</h1>
                                <li><Link className="nav-link" to="#Title1">Alorem</Link></li>
                                <li><Link className="nav-link" to="#Title2">Artist Name</Link></li>
                                <li><Link className="nav-link" to="#Title3">Blorem</Link></li>
                                <li><Link className="nav-link" to="#Title4">Clorem</Link></li>
                                <li><Link className="nav-link" to="#Title5">Alorem</Link></li>
                                <li><Link className="nav-link" to="#Title6">Azorem</Link></li>
                                <li><Link className="nav-link" to="#Title1">Alorem</Link></li>
                                <li><Link className="nav-link" to="#Title2">Artist Name</Link></li>
                                <li><Link className="nav-link" to="#Title3">Blorem</Link></li>
                                <li><Link className="nav-link" to="#Title4">Clorem</Link></li>
                                <li><Link className="nav-link" to="#Title5">Alorem</Link></li>
                                <li><Link className="nav-link" to="#Title6">Azorem</Link></li>
                                <li><Link className="nav-link" to="#Title1">Alorem</Link></li>
                            </ul>
                        </nav>
                        <nav className="marketplace-card">
                            <div className="container-fluid">
                                <div className="row justify-content-between">
                                    <h4>Marketplace</h4>
                                    <h4>Sort By <i className="fa fa-arrow-up"></i><i className="fa fa-arrow-down"></i></h4>
                                </div>
                                <div className="row">
                                    <div className="card mt-4">
                                        <Link to="/SpecificItem">
                                            <img src={card1} className="card-img-top" alt="" />
                                        </Link>
                                        <Link to="/SpecificItem">
                                            <div className="card-body">
                                                <h3>Artwork Title</h3>
                                                <span><strong>Not for Sale</strong>&emsp;<small>1 OF 26</small></span>
                                                <p className="card-text"><span><small>LAST SOLD</small>&emsp;<strong>$89,000.00</strong></span></p>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="card mt-4">
                                        <Link to="/SpecificItem">
                                            <img src={card2} className="card-img-top" alt="" />
                                        </Link>
                                        <Link to="/SpecificItem">
                                            <div className="card-body">
                                                <h3>Artwork Title</h3>
                                                <span><strong>$ 60,000.00</strong>&emsp;<small>2 OF 26</small></span>
                                                <p className="card-text"><span><small>HIGHEST BID</small>&emsp;<strong>$49,000.00</strong></span></p>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="card mt-4">
                                        <Link to="/SpecificItem">
                                            <img src={card3} className="card-img-top" alt="" />
                                        </Link>
                                        <Link to="/SpecificItem">
                                            <div className="card-body">
                                                <h3>Artwork Title</h3>
                                                <span><strong>$ 50,000.00</strong>&emsp;<small>3 OF 26</small></span>
                                                <p className="card-text"><span><small>HIGHEST BID</small>&emsp;<strong>$13,000.00</strong></span></p>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="card mt-4">
                                        <Link to="/SpecificItem">
                                            <img src={card4} className="card-img-top" alt="" />
                                        </Link>
                                        <Link to="/SpecificItem">
                                            <div className="card-body">
                                                <h3>Artwork Title</h3>
                                                <span><strong>$ 40,000.00</strong>&emsp;<small>4 OF 26</small></span>
                                                <p className="card-text"><span><small>HIGHEST BID</small>&emsp;<strong>$8,000.00</strong></span></p>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="card mt-4">
                                        <Link to="/SpecificItem">
                                            <img src={card5} className="card-img-top" alt="" />
                                        </Link>
                                        <Link to="/SpecificItem">
                                            <div className="card-body">
                                                <h3>Artwork Title</h3>
                                                <span><strong>Not for Sale</strong>&emsp;<small>5 OF 26</small></span>
                                                <p className="card-text"><span><small>LAST SOLD</small>&emsp;<strong>$89,000.00</strong></span></p>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="card mt-4">
                                        <Link to="/SpecificItem">
                                            <img src={card6} className="card-img-top" alt="" />
                                        </Link>
                                        <Link to="/SpecificItem">
                                            <div className="card-body">
                                                <h3>Artwork Title</h3>
                                                <span><strong>$ 60,000.00</strong>&emsp;<small>6 OF 26</small></span>
                                                <p className="card-text"><span><small>HIGHEST BID</small>&emsp;<strong>$49,000.00</strong></span></p>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="card mt-4">
                                        <Link to="/SpecificItem">
                                            <img src={card7} className="card-img-top" alt="" />
                                        </Link>
                                        <Link to="/SpecificItem">
                                            <div className="card-body">
                                                <h3>Artwork Title</h3>
                                                <span><strong>$ 50,000.00</strong>&emsp;<small>7 OF 26</small></span>
                                                <p className="card-text"><span><small>HIGHEST BID</small>&emsp;<strong>$13,000.00</strong></span></p>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="card mt-4">
                                        <Link to="/SpecificItem">
                                            <img src={card8} className="card-img-top" alt="" />
                                        </Link>
                                        <Link to="/SpecificItem">
                                            <div className="card-body">
                                                <h3>Artwork Title</h3>
                                                <span><strong>$ 40,000.00</strong>&emsp;<small>8 OF 26</small></span>
                                                <p className="card-text"><span><small>HIGHEST BID</small>&emsp;<strong>$8,000.00</strong></span></p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </nav>
                    </main>
                </div>
                {/* MArketplace area end */}
            </div>
        )
    }
};

export default FilteredArtworkViewCollection;